var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "450", persistent: true },
      model: {
        value: _vm.dialogIsOpen,
        callback: function($$v) {
          _vm.dialogIsOpen = $$v
        },
        expression: "dialogIsOpen"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass:
            "dialog-box home-form-container building_structure_dialog"
        },
        [
          _c("h2", { staticClass: "fraction-title" }, [
            _vm._v(
              _vm._s(
                _vm.objectToEdit
                  ? _vm.$t("Edit") + " " + _vm.$tc("Fraction", 1)
                  : _vm.$t("New") + " " + _vm.$tc("Fraction", 1)
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "div",
                { staticClass: "fraction-form-item medium" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("Phase")))]),
                  _vm._v(" "),
                  _c("treeselect", {
                    staticClass: "form-input-select vertical-input-select",
                    attrs: {
                      options: _vm.phaseOption,
                      disableFuzzyMatching: ""
                    },
                    model: {
                      value: _vm.objectData.status,
                      callback: function($$v) {
                        _vm.$set(_vm.objectData, "status", $$v)
                      },
                      expression: "objectData.status"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: "" + _vm.$t("Client") + " ID",
                  "input-type": "number",
                  size: "medium",
                  value: _vm.objectData.client_id
                },
                model: {
                  value: _vm.objectData.client_id,
                  callback: function($$v) {
                    _vm.$set(_vm.objectData, "client_id", $$v)
                  },
                  expression: "objectData.client_id"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-center" }, [
            _c(
              "div",
              { staticClass: "fraction-form-item" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("ContractStatus")))]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    options: _vm.contractOptions,
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.objectData.contract_status,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "contract_status", $$v)
                    },
                    expression: "objectData.contract_status"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fraction-form-item" },
              [
                _c("label", [
                  _vm._v(_vm._s("" + _vm.$t("ClassificationType")))
                ]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    options: _vm.classificationOptions,
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.objectData.classification_type,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "classification_type", $$v)
                    },
                    expression: "objectData.classification_type"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c("input-field", {
                attrs: {
                  label: "" + _vm.$tc("Address", 1),
                  "input-type": "text",
                  size: "large",
                  value: _vm.objectData.address
                },
                model: {
                  value: _vm.objectData.address,
                  callback: function($$v) {
                    _vm.$set(_vm.objectData, "address", $$v)
                  },
                  expression: "objectData.address"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "fraction-form-item small" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$tc("Floor", 1) + " *"))]),
                  _vm._v(" "),
                  _c("treeselect", {
                    staticClass: "form-input-select vertical-input-select",
                    attrs: {
                      options: _vm.floors,
                      disableFuzzyMatching: "",
                      disabled: _vm.allFractions
                        ? _vm.objectToEdit
                          ? true
                          : false
                        : true
                    },
                    model: {
                      value: _vm.objectData.floor_uuid,
                      callback: function($$v) {
                        _vm.$set(_vm.objectData, "floor_uuid", $$v)
                      },
                      expression: "objectData.floor_uuid"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-center" }, [
            _c(
              "div",
              { staticClass: "fraction-form-item", style: { flex: "1" } },
              [
                _c("label", [_vm._v(_vm._s("" + _vm.$t("Cable-inReference")))]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    options: _vm.cableTypeFiveOptions,
                    disableFuzzyMatching: "",
                    disabled: !!!_vm.objectData.floorbox_uuid
                  },
                  model: {
                    value: _vm.objectData.cable_in_material_id,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "cable_in_material_id", $$v)
                    },
                    expression: "objectData.cable_in_material_id"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { style: { flex: "1" } },
              [
                _c("input-field", {
                  attrs: {
                    label: "" + _vm.$t("Length"),
                    "input-type": "float",
                    size: "large",
                    value: _vm.objectData.cable_in_length,
                    fieldDisabled: !!!_vm.objectData.floorbox_uuid
                  },
                  model: {
                    value: _vm.objectData.cable_in_length,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "cable_in_length", $$v)
                    },
                    expression: "objectData.cable_in_length"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fraction-form-item", style: { flex: "1" } },
              [
                _c("label", [_vm._v(_vm._s("" + _vm.$tc("Owner", 1)))]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    options: _vm.ownerOptions,
                    disableFuzzyMatching: "",
                    disabled: !!!_vm.objectData.floorbox_uuid
                  },
                  model: {
                    value: _vm.objectData.cable_in_owner_id,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "cable_in_owner_id", $$v)
                    },
                    expression: "objectData.cable_in_owner_id"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              label: "" + _vm.$t("Comments"),
              "input-type": "textarea",
              size: "large",
              value: _vm.objectData.comment
            },
            model: {
              value: _vm.objectData.comment,
              callback: function($$v) {
                _vm.$set(_vm.objectData, "comment", $$v)
              },
              expression: "objectData.comment"
            }
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  staticClass: "secondary-button",
                  attrs: { ripple: false, text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close-dialog")
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Cancel")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "main-button",
                  attrs: {
                    disabled: !_vm.objectCanBeCreated(),
                    ripple: false,
                    text: ""
                  },
                  on: { click: _vm.saveObject }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.objectToEdit ? _vm.$t("Edit") : _vm.$t("Create")
                      ) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-118cedf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-118cedf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/FractionForm.vue
// module id = null
// module chunks = 